<template>
	<div class=""><!-- customFixed-vue darkFadeBG -->
		<div class="newsResize">
			<div class="topSettingHead position-relative border-bottom p-3">
				<p class="f-14 mb-0">{{$t('news') }} </p>
				<span class="closePOP" @click.prevent="$parent.newsPopup = false"><feather size="13px" type="x"></feather></span>
			</div>
			<div class="scrollbar popIf-scroll">
				<div v-if="newsData.records.length > 0">
					<div class="mainTab-one" v-for="list,index in newsData.records">
					<!-- <div class="mainTab-one" v-for="list in newsData.records"> -->
						<div class="elementHistoy border-bottom">
					 		<!-- <span class="buttonType">{{list.category}}</span>
					 		<h5>{{list.title}}</h5>
					 		<p v-html="list.description"></p>
					 		<div class="d-flex justify-content-between align-items-center maxSpace">
					 			<p class="uppercase m-0">{{list.tags}}</p>
					 			<span class="date d-flex align-items-center"><feather class="mr-1" size="12px" type="calendar"></feather>{{fromDate(list.created)}}</span>
					 		</div> -->
					 		<div class="media newsObject">
							  <span class="mediaImg">
							  	<img class="mr-3" :src="list.image" alt="Image" v-if="list.image">
							  	<img class="mr-3" src="../../../../static/website/images/noImage.png" alt="Image" v-else>
							  </span>
							  <div class="media-body">
							    <span class="buttonType">{{list.category}}</span>
							    <h5>{{list.title}}</h5>
							    <span v-if="index == selectedIndex"><p class="f-14" v-html="list.description"></p><span class="showMore red font-weight-bold f-14" @click="changeIndex(index)">{{$t('show_less') }}</span></span>
							    <span v-else><p v-html="list.description.slice(0,170)"></p><span class="showMore font-weight-bold f-14" @click="changeIndex(index)">{{$t('show_more') }} </span></span>
							    <div class="d-flex justify-content-between align-items-center maxSpace">
					 				<p class="uppercase m-0 green">{{list.tags}}</p>
						 			<span class="date d-flex align-items-center"><feather class="mr-1" size="12px" type="calendar"></feather>{{fromDate(list.created)}}</span>
						 		</div>
							  </div>
							</div>
					 	</div>
					</div>
				</div>
                <div v-else class="noData border-0 py-4">
                    <img src="../../../../static/website/images/noData.svg" alt="Icon">
                    <p><span>{{$t('no_data_found') }} </span></p>
                </div>
			</div>
		</div>
	</div>
</template>
<script>
	import { commonAllmixins } from '@/plugins/commonAll'
	import moment from 'moment'
	export default {
	    name: 'News Popup',
	    mixins: [commonAllmixins],
	    data() {
	        return {
				newsType:false,
				selectedIndex : -1
	        }
	    },
	    methods:{
	    	changeIndex(index){
	    		if(this.selectedIndex == index){
	    			this.selectedIndex = -1
	    		}else{
	    			this.selectedIndex = index
	    		}
	    	},
	    	fromDate(date){
	    		let d = new Date(date)
	    		return moment(d).fromNow()
	    	}
	    },
	
	}
</script>


// WEBPACK FOOTER //
// src/components/website/shared/news-popup.vue